<template>
	<button @click="favouriteStudy(true)" class="ChampionButton BestFitButton">
		<i class="HeartIcon" :class="wishlisted ? 'lnr-heart-full' : 'lnr-heart'"> </i>
		{{ wishlisted ? 'Added to wishlist' : 'Add to wishlist' }}
	</button>
</template>

<style lang="scss" scoped src="./BestFit.scss"></style>
<script lang="ts" src="./BestFit.ts"></script>
